module.exports = __webpack_public_path__ + "img/icon_logout.ac24d04c.svg";